import styled, { css } from 'styled-components'
import { device } from '../../../styles/Breakpoints'

export const MarketectureContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;

	p {
		font-size: var(--font-small-size);
		line-height: var(--font-small-line-height);
	}

	@media ${device.md} {
		grid-template-columns: 100px 1fr 1fr;

		p {
			font-size: inherit;
			line-height: inherit;
		}
	}
`

export const MSection = styled.div`
	display: flex;
	width: 100%;
	margin-bottom: 10px;

	@media ${device.md} {
		display: grid;
		grid-template-columns: 15% 1fr;
		gap: 10px;
		grid-template-columns: 15% 1fr;
	}

	.sectionTitle {
		display: none;

		@media ${device.md} {
			grid-column-start: 1;
			border-right: 5px solid var(--grey-22);
			text-align: right;
			display: flex;
			flex-direction: column;
			justify-content: center;

			h3 {
				margin-right: 20px;
			}
		}
	}

	.sectionRows {
		display: flex;
		flex-direction: column;
		width: 100%;

		@media ${device.md} {
			grid-column-start: 2;
		}
	}

	${({ sectionRow }) =>
		sectionRow === 'topRow' &&
		css`
			.sectionRows {
				display: grid;
				grid-template-columns: 1fr;

				@media ${device.sm} {
					gap: 10px;
					grid-template-columns: 1fr 1fr;
				}
			}
		`}

	${({ sectionRow }) =>
		sectionRow === 'middleRow' &&
		css`
			.sectionRows {
				border-top: 5px solid var(--green);
			}
		`}

	${({ sectionRow }) =>
		sectionRow === 'bottomRow' &&
		css`
			${'' /* .sectionTitle {
				display: none;
			} */}
		`}
`

export const MCard = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;
	text-align: center;
	height: 100%;

	img {
		max-width: 50px;
	}
`

export const MFlip = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	cursor: pointer;
	background-color: var(--green-44);

	&.topRowCard {
		background-color: #fff;
		border: 1px solid var(--green);
		height: 210px;

		&:after {
			content: '';
			position: absolute;
			margin: 0 auto;
			width: 0;
			height: 0;
			border-top: solid 5px var(--green);
			border-left: solid 5px transparent;
			border-right: solid 5px transparent;
			top: 100%;
			left: 50%;
		}
	}

	&.engines {
		height: 200px;

		&:before,
		&:after {
			content: '';
			position: absolute;
			margin: 0 auto;
			width: 0;
			height: 0;
			border-top: solid 5px var(--green);
			border-left: solid 5px transparent;
			border-right: solid 5px transparent;
			transform: rotate(180deg);
		}

		&:before {
			display: none;

			@media ${device.sm} {
				display: block;
				left: 24.9%;
				top: -10px;
			}
		}

		&:after {
			top: -10px;
			left: 50%;

			@media ${device.sm} {
				left: 75.5%;
			}
		}

		@media ${device.md} {
			height: 150px;
		}
	}

	&.flowRow {
		height: 210px;

		&:last-child {
			&:before,
			&:after {
				content: '';
				position: absolute;
				margin: 0 auto;
				width: 0;
				height: 0;
				border-top: solid 5px var(--green);
				border-left: solid 5px transparent;
				border-right: solid 5px transparent;
				top: 100%;
				left: 50%;
			}

			&:before {
				display: none;

				@media ${device.sm} {
					display: block;
					left: 24.9%;
				}
			}

			&:after {
				left: 50%;

				@media ${device.sm} {
					left: 75.5%;
				}
			}
		}
	}

	&.bottomFlip {
		height: 340px;
		background-color: var(--grey-44);

		@media ${device.md} {
			height: 170px;
		}

		&:before,
		&:after {
			content: '';
			position: absolute;
			margin: 0 auto;
			width: 0;
			height: 0;
			border-top: solid 5px var(--green);
			border-left: solid 5px transparent;
			border-right: solid 5px transparent;
			transform: rotate(180deg);
		}

		&:before {
			display: none;

			@media ${device.sm} {
				display: block;
				left: 24.9%;
				top: -5px;
			}
		}

		&:after {
			top: -5px;
			left: 50%;

			@media ${device.sm} {
				left: 75.5%;
			}
		}

		.flipCardInner {
			position: relative;
			width: 100%;
			height: 100%;
			text-align: center;
			transition: transform 0.8s;
			transform-style: preserve-3d;
		}
	}
`

export const FlipCardFront = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	height: 100%;

	.titleContainer {
		width: 100%;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		&.topRowCard {
			background-color: var(--green);
			color: #fff;
		}

		&.engines {
			display: none;
		}

		&.flowRow {
			h3 {
				/* position: absolute; */
				background-color: var(--green-44);
				padding: 0 10px;
				/* top: -10px; */
				z-index: 10;

				@media ${device.lg} {
					/* top: 9px; */
				}
			}
		}

		&.bottomFlip {
			display: none;
		}
	}

	.cardInfo {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		width: 100%;
		height: 100%;
		align-items: center;
		justify-content: center;

		img {
			max-width: 50px;
		}

		&.flowRow {
			position: relative;
			border-top: 3px solid var(--green);
			width: 90%;

			&:before,
			&:after {
				content: '';
				border: 1px solid var(--green);
				position: absolute;
				height: 30px;
				top: 0;
			}

			&:before {
				left: 0;
			}

			&:after {
				right: 0;
			}

			${MCard} {
				padding-top: 10px;
			}
		}

		&.engines {
			grid-template-columns: 1fr;

			@media ${device.md} {
				grid-template-columns: 1fr 1fr;
			}

			${MCard} {
				display: flex;
				flex-direction: row;

				p {
					font-size: var(--font-title3-size);
					line-height: var(--font-title3-line-height);
					font-weight: 600;
				}
			}
		}

		&.bottomFlip {
			grid-template-columns: 1fr 1fr;

			@media ${device.md} {
				grid-template-columns: 1fr 1fr 1fr 1fr;
			}

			img {
				max-width: 150px;
				max-height: 50px;

				@media ${device.md} {
					max-width: 200px;
					max-height: 70px;
				}
			}

			${MCard} {
				h3 {
					font-weight: 600;
				}
			}
		}
	}
`

export const FlipCardBack = styled.div`
	background-color: var(--green);
	color: #fff;
	padding: 10px;
	height: 100%;
	border: 1px solid var(--grey);

	.titleContainer {
		&.topRowCard,
		&.engines,
		&.flowRow,
		&.bottomFlip {
			p {
				:first-of-type {
					margin-top: 0;
				}

				:last-of-type {
					margin-bottom: 0;
				}
			}
		}
	}
`
